module.exports = __webpack_public_path__ + "dist/media/ec_comp_gallery.ba30230a.svg";